import React, { PureComponent } from "react";
import PropTypes from 'prop-types';
import FontAwesome from "react-fontawesome";
import _ from "lodash";
import autoBind from "react-autobind";

let BACKGROUND_COLOR, BACKGROUND_COLOR_DISABLED, BORDER_RADIUS, BORDER_COLOR, BORDER_WIDTH, BORDER_STYLE, COLOR_DISABLED, COLOR, MARGIN, SIZE, CHECKED_ICON_NAME;
const DEFAULT_STYLE = "player-item-radio";

class RadioButton extends PureComponent {
	constructor(props) {
		super(props);

		const theme = this.props.activityTheme ? this.props.activityTheme : window.activityTheme;

		let _state = {
			backgroundColor: '#ffffff',
			backgroundColorDisabled: '#cccccc',
			borderRadius: 20,
			borderWidth: 2,
			borderStyle: "solid",
			borderColor: '#000000',
			color: this.props.checkedColor === "green" ? theme.checkedGreen : this.props.checkedColor === "blue" ? theme.checkedBlue : theme.checkedBlack,
			colorDisabled: '#aaaaaa',
			margin: 2,
			name: '',
			onChange: null,
			size: this.props.size ? this.props.size : 30,
			checkedIconName: 'circle'
		};

		if (window.activityTheme) {
			_state = _.assign({}, _state, _.get(window.activityTheme, "item.choice.radio", {}));
		}

		this.state = _state;
		autoBind(this);
	}

	_toggleCheck() {
		const value = this.props.value;
		this.props.onChange && this.props.onChange({ target: { value } });
		this.props.onClick && this.props.onClick({ target: { value } });
	}

	render() {


		var offset = 5;

		BACKGROUND_COLOR = this.state.backgroundColor;
		BACKGROUND_COLOR_DISABLED = this.state.backgroundColorDisabled;
		BORDER_RADIUS = this.state.borderRadius;
		BORDER_WIDTH = this.state.borderWidth;
		BORDER_COLOR = this.state.borderColor;
		BORDER_STYLE = this.state.borderStyle;
		COLOR = this.state.color;
		COLOR_DISABLED = this.state.colorDisabled;
		MARGIN = this.state.margin;
		SIZE = this.state.size;
		CHECKED_ICON_NAME = this.state.checkedIconName;
		const className = (this.props.className) ? this.props.className : DEFAULT_STYLE;
		var checkbox;

		let _style = { flex: 1, alignItems: 'center' };
		_style = _.assign(_style, _.get(window.activityTheme, "item.choice.text", {}));
		if (this.props.style) {
			_style = _.assign({ paddingLeft: "10px", paddingRight: "10px" }, _style, this.props.style);
		}

		const textAlign = this.props.style && this.props.style.textAlign && this.props.style.textAlign === "right" ? "right" : this.props.style && this.props.style.textAlign ? "left" : null;
		const label = this.props.label;

		let textStyle = {};
		if (window.activityTheme) {
			textStyle = _.assign({ flex: 1, paddingLeft: "10px", paddingRight: "10px" }, textStyle, _.get(window.activityTheme, "item.choice.text", {}));
		}

		let labelOnly = _.get(this.props, "item.labelOnly");

		if (this.props.disabled) {
			if (labelOnly !== true) {
				checkbox =
					<div style={_style} className={className}>
						{label && textAlign === "right" && label}
						<div underlayColor='transparent'
							style={{
								backgroundColor: BACKGROUND_COLOR_DISABLED, borderColor: COLOR_DISABLED,
								borderRadius: BORDER_RADIUS, borderWidth: BORDER_WIDTH,
								height: SIZE, margin: MARGIN, width: SIZE, borderStyle: BORDER_STYLE, minWidth: SIZE, minHeight: SIZE
							}}>

							<div style={{ flex: 1, alignItems: 'center', justifyContent: 'center' }}>
								{this.props.checked &&
									<FontAwesome name={CHECKED_ICON_NAME} style={{ fontSize: (SIZE - offset), color: COLOR }} />}
							</div>
						</div>
						{label && textAlign === "left" && label}
						{label && !textAlign && <div style={textStyle}>{this.props.label}</div>}
					</div>;
			} else {
				checkbox = <div style={_style}>{this.props.label}</div>
			}
		} else {
			if (labelOnly !== true) {
				checkbox =
					<div style={_style} className={className}>
						{label && textAlign === "right" && label}
						<div
							onClick={this._toggleCheck}
							style={{
								backgroundColor: BACKGROUND_COLOR, borderColor: BORDER_COLOR,
								borderRadius: BORDER_RADIUS, borderWidth: BORDER_WIDTH,
								height: SIZE, margin: MARGIN, width: SIZE, borderStyle: BORDER_STYLE, minWidth: SIZE, minHeight: SIZE
							}}>
							<div style={{ flex: 1, alignItems: 'center', justifyContent: 'center', display: "flex", width: "100%", height: "100%" }}>
								{this.props.checked &&
									<FontAwesome name={CHECKED_ICON_NAME} style={{ fontSize: (SIZE - offset), color: COLOR }} />}
							</div>
						</div>
						{label && textAlign === "left" && label}
						{label && !textAlign && <div style={textStyle}>{this.props.label}</div>}
					</div>;
			} else {
				checkbox = <div style={_style}>{this.props.label}</div>
			}
		}

		return (checkbox);
	}

}

RadioButton.propTypes = {
	checked: PropTypes.bool,
	name: PropTypes.string,
	onChange: PropTypes.func,
	size: PropTypes.number,
	style: PropTypes.object,
}

export default RadioButton;